import React from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import person from "../assets/images/settings-person.png";
import order_history from "../assets/images/order-history.png";
import address from "../assets/images/address.png";
import points from "../assets/images/points.png";
import offer from "../assets/images/offer.png";
import feedback from "../assets/images/feedback.png";
import language from "../assets/images/language.png";
import privacy from "../assets/images/privacy-policy.png";
import terms from "../assets/images/terms&condtion.png";
import fb from "../assets/images/fb.png";
import twitter from "../assets/images/X.png";
import instagram from "../assets/images/instagram.png";
import linkedIn from "../assets/images/linkedIn.png";
import Header from "../components/Header";

const Account = () => {
  const menuItems = [
    { label: "Profile", img: person, link:'/profile' },
    { label: "Order History", img: order_history, link:'/my-orders' },
    { label: "Addresses", img: address, link:'/address-list' },
    { label: "Saved Cards", icon: "bi-credit-card-2-front", link:'/saved-cards' },
    { label: "Loyalty Points", img: points, link:'/points' },
    { label: "Offers", img: offer, link:'/promotions' },
    // { label: "Feedback", img: feedback, link:'/profile' },
    { label: "Language", img: language, link:'/profile' },
    { label: "Privacy Policy", img: privacy, link:'/privacy-policy', link:'https://ir.wingstop.com/' },
    { label: "Terms & Conditions", img: terms, link:'/terms-conditions', link:'https://ir.wingstop.com/' },
  ];
  return (
    <div className="main-heading items-details-main container">
      
      <Header title={'Account'} />
      

      <div>
        {menuItems.map((item, index) => {
          const content = (
            <div
              key={index}
              className="d-flex justify-content-between align-items-center border-top border-bottom"
            >
              <div className="d-flex justify-content-start align-items-center px-3 py-2">
                {item.icon ? (
                  <i
                    className={`bi ${item.icon} mx-3 text-dark`}
                    style={{ fontSize: "25px", width: "25px", height: "25px" }}
                  ></i>
                ) : (
                  <img
                    src={item.img}
                    alt={item.label}
                    className="mx-3"
                    style={{ width: "25px", height: "25px" }}
                  />
                )}
                <p className="mt-3 fs-6">{item.label}</p>
              </div>
              <div>
                <MdKeyboardArrowRight fontSize={30} className="me-3" />
              </div>
            </div>
          );

          return (
            <Link
              to={item.link}
              key={index}
              className="text-decoration-none text-dark"
            >
              {content}
            </Link>
          );

        })}
      </div>

      <div className="d-flex justify-content-center gap-4 py-4">
        <a className="social-icon-wrapper" target="_blank" href="https://www.facebook.com/Wingstop/">
          <img
            src={fb}
            alt="Facebook Icon"
            className="social-icon"
            style={{ width: "15px" }}
          />
        </a>
        <a className="social-icon-wrapper"  target="_blank" href="https://www.instagram.com/wingstop/">
          <img src={instagram} alt="Instagram Icon" className="social-icon" />
        </a>
        <a className="social-icon-wrapper"  target="_blank" href="https://x.com/wingstop/">
          <img src={twitter} alt="Twitter Icon" className="social-icon" />
        </a>
        
      </div>

      <div className="text-center pb-4" style={{ color: "#7e7e7e" }}>
        Copyright @2025 Wingstop - Version: 0.1
      </div>
    </div>
  );
};

export default Account;
